export default function SystemInvoice() {
  return (
    <div className="document-form">
      <fieldset>
        <legend>DANE DOKUMENTU</legend>

        <label>
          Typ dokumentu
          <input type="text" name="documentType" />
        </label>

        <label>
          Waluta
          <input type="text" name="currency" />
        </label>

        <label>
          Data wprowadzenia
          <input type="date" name="entryDate" />
        </label>

        <label>
          Magazyn
          <select name="warehouse">
            <option value="">— wybierz —</option>
            <option value="BT">BT – Biuro Tłumaczeń</option>
            <option value="H">H – Hotel</option>
          </select>
        </label>

        <label>
          Typ płatności
          <select name="paymentType">
            <option value="">— wybierz —</option>
            <option value="cash">Gotówka</option>
            <option value="card">Karta</option>
            <option value="transfer">Przelew</option>
          </select>
        </label>

        <label>
          Termin sprzedaży
          <input type="date" name="saleDeadline" />
        </label>

        <label>
          Nr dokumentu źródłowego
          <input type="text" name="sourceDocumentNumber" />
        </label>

        <label>
          Data dokumentu źródłowego
          <input type="date" name="sourceDocumentDate" />
        </label>

        <label>
          Data sprzedaży dok. źródł.
          <input type="date" name="sourceSaleDate" />
        </label>

        <label>
          Data wpływu
          <input type="date" name="receivedDate" />
        </label>

        <label>
          Termin płatności
          <input type="date" name="paymentDueDate" />
        </label>

        <label>
          Licz od
          <select name="countFrom">
            <option value="gross">brutto</option>
            <option value="net">netto</option>
          </select>
        </label>
      </fieldset>

      <fieldset>
        <legend>SPRZEDAWCA</legend>

        <label>
          Nazwa
          <input type="text" name="sellerName" />
        </label>

        <label>
          Ulica
          <input type="text" name="street" />
        </label>

        <label>
          Numer domu
          <input type="text" name="houseNumber" />
        </label>

        <label>
          Numer lokalu
          <input type="text" name="apartmentNumber" />
        </label>

        <label>
          Miejscowość
          <input type="text" name="city" />
        </label>

        <label>
          Poczta
          <input type="text" name="postOffice" />
        </label>

        <label>
          Kod pocztowy
          <input type="text" name="postalCode" />
        </label>

        <label>
          NIP
          <input type="text" name="nip" />
        </label>

        <label>
          Telefon
          <input type="tel" name="phone" />
        </label>

        <label>
          E-mail
          <input type="email" name="email" />
        </label>

        <label>
          Fax
          <input type="text" name="fax" />
        </label>
      </fieldset>
    </div>
  );
}
